import { combineReducers } from 'redux';

import httpConfig from './httpConfig';
import contactApplications from './contactApplications';
import contactSchoolsChecklist from './contactSchoolsChecklist';
import relatedContacts from './relatedContacts';
import oneTimeActions from './oneTimeActions';
import entities from './entities';

export default {
  entities: combineReducers(entities),
  contactApplications,
  contactSchoolsChecklist,
  relatedContacts,
  httpConfig,
  oneTimeActions,
};
